import React from 'react';
import { TextAreaField } from '@/components/form/fields/TextAreaField';
import { Button } from 'alurkerja-ui';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { InputField } from '@/components/form/fields/InputField';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { ITestCaseSchema } from '@/api/testCase';

export const StepForm: React.FC = () => {
  const form = useFormContext<ITestCaseSchema>();
  const { fields, append, remove, insert } = useFieldArray({
    control: form.control,
    name: 'steps',
  });

  if (fields.length === 0) {
    append({
      position_step: 0,
      title: null,
      expected_result: null,
    });

    form.trigger('steps');
  }

  return (
    <div className="flex flex-col gap-2 px-3">
      {fields.map((field, index) => {
        return (
          <div
            className="flex flex-row items-center gap-10"
            key={`step-${field.id}`}
          >
            <InputField name={`steps.${index}.position_step`} type="hidden" />

            <TextAreaField
              name={`steps.${index}.title`}
              label="Step Description"
              hasRequiredAsterisk
            />

            <TextAreaField
              name={`steps.${index}.expected_result`}
              label="Expected Result"
              hasRequiredAsterisk
            />

            <div className="flex flex-row gap-3">
              <Button
                color="red"
                icon={<FaTrash />}
                type="button"
                onClick={() => {
                  if (fields.length > 1) remove(index);
                }}
              >
                Remove
              </Button>

              <OutlineButton
                icon={<FaPlus />}
                onClick={() => {
                  insert(index + 1, {
                    position_step: 0,
                    title: null,
                    expected_result: null,
                  });

                  form.trigger('steps');
                }}
              >
                Add
              </OutlineButton>
            </div>
          </div>
        );
      })}
    </div>
  );
};
